<template>
  <b-modal
    ref="bModal"
    size="xs"
    :title="$t('component.printLabelsModal.saveTemplate')"
    centered
    modal-class="save-notification-template"
    qa="save-notification-template-modal"
    @hide="onHide"
  >
    <b-row class="py-3 px-4 mb-4">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <div class="form-label">
          <label>{{ $t('diagnosis.notificationsModal.templateName') }}*</label>
        </div>
        <vt-input
          v-model="title"
          v-validate="'required'"
          qa="save-notification-template-modal-template-name-input"
          name="templateName"
          class="form-control-sm"
        />
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            qa="save-notification-template-modal-cancel-button"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-7 text-right">
          <div v-if="textTemplateId">
            <b-button
              qa="save-notification-template-modal-save-button"
              size="sm"
              class="btn__outline mr-2"
              @click="createTemplate"
            >
              <i
                class="fal fa-save mr-2"
                aria-hidden="true"
              />
              {{ $t('global.save') }}
            </b-button>
            <b-button
              qa="save-notification-template-modal-overwrite-button"
              size="sm"
              class="btn--primary"
              @click="updateTemplate"
            >
              <i
                class="fal fa-arrow-to-bottom mr-2"
                aria-hidden="true"
              />
              {{ $t('global.overwrite') }}
            </b-button>
          </div>
          <div v-else>
            <b-button
              qa="save-notification-template-modal-save-button"
              size="sm"
              class="btn--primary mx-2"
              @click="createTemplate"
            >
              <i
                class="fal fa-save mr-2"
                aria-hidden="true"
              />
              {{ $t('global.save') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
    name: 'SaveNotificationTemplate',
    data() {
        return {
            title: '',
            textTemplateId: null
        }
    },
    methods: {
        show(title, textTemplateId) {
            this.title = title
            this.textTemplateId = textTemplateId
            this.$refs.bModal.show()
        },
        createTemplate() {
            this.$emit('createTemplate', this.$data)
            this.hide()
        },
        updateTemplate() {
            this.$emit('updateTemplate', this.$data)
            this.hide()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        onHide() {
            this.$_cleanComponentData()
        }
    }
}

</script>

<style lang="scss">
    .save-notification-template .modal-body {
        padding: 10px;
    }
</style>

<style lang="scss" scoped>
    .save-notification-template span {
        font-size: font-size(very-normal);
    }
</style>
